// extracted by mini-css-extract-plugin
export var bottom = "Footer-module--bottom--1c8d4";
export var contactInfo = "Footer-module--contactInfo--fcef8";
export var copyright = "Footer-module--copyright--3317f";
export var footer = "Footer-module--footer--6e743";
export var link = "Footer-module--link--815cb";
export var social = "Footer-module--social--2d370";
export var top = "Footer-module--top--930c1";